// Single read point for the storage cargo blob. Nothing else in the app should
// reach into _cargo for storage settings.
function cargo() {
  const root = (typeof _cargo !== 'undefined' && _cargo) || {};
  return root.storage || {};
}

export function writeDriver() {
  return cargo().write || '';
}

export function variantNames() {
  return cargo().variants || [];
}

export function isVariant(name) {
  return !!name && variantNames().indexOf(String(name)) !== -1;
}

export function maxUploadSizeMB() {
  return parseInt(cargo().max_upload_size, 10) || 10;
}

export function publicUrlBase() {
  return cargo().public_url_base || '';
}

export function variantConfig() {
  return cargo().variant_config || {};
}
